import styled from "styled-components";

import { adminTokens } from "@pages/AdminDashboard/theme/adminTokens";
import { Note, NoteTone } from "@pages/AdminDashboard/ui/Note";
import { UiKitSection } from "@pages/AdminDashboard/ui/UiKitSection";

const [spaceXs, , spaceMd, , spaceXl] = adminTokens.spacing;

const shortTexts: Record<NoteTone, string> = {
  info: "Replace Order isn't available: this Order has no invoice to fund a replacement.",
  error:
    "The pharmacy rejected this Order. An error is final at the pharmacy, so it can't be re-submitted.",
};

const longTexts: Record<NoteTone, string> = {
  info: "Replace Order isn't available: this Order has no invoice to fund a replacement. An Order gets its invoice when the User pays for the consultation, so an Order made by hand or imported from another system may have none; nothing can be charged or refunded from here.",
  error:
    "The pharmacy rejected this Order. An error is final at the pharmacy, so it can't be re-submitted. Replace it to send a new Order under the same payment: the User is not charged again, keeps the Case and gets the new tracking number when the new Order ships.",
};

const examples: { name: string; tone: NoteTone; text: string }[] = [
  { name: "Info, short text", tone: "info", text: shortTexts.info },
  { name: "Info, long text", tone: "info", text: longTexts.info },
  { name: "Error, short text", tone: "error", text: shortTexts.error },
  { name: "Error, long text", tone: "error", text: longTexts.error },
];

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(320px, 100%), 1fr));
  gap: ${spaceMd}px;
  margin-bottom: ${spaceXl}px;
`;

const Example = styled.div.attrs({ role: "group" })`
  display: flex;
  flex-direction: column;
  gap: ${spaceXs}px;
  border: 1px solid ${adminTokens.color.border};
  border-radius: ${adminTokens.radius.row}px;
  padding: ${spaceMd}px;
`;

const Caption = styled.span`
  color: ${adminTokens.color.inkSoft};
  font-family: ${adminTokens.typeScale.meta.fontFamily};
  font-size: ${adminTokens.typeScale.meta.fontSize};
`;

// Each tone with a short and a long text, under its own label (NOTE-R5, UIKIT-R8).
export const NoteSection = () => (
  <UiKitSection title="Note">
    <Grid>
      {examples.map(({ name, tone, text }) => (
        <Example key={name} aria-label={name}>
          <Caption>{name}</Caption>
          <Note tone={tone}>{text}</Note>
        </Example>
      ))}
    </Grid>
  </UiKitSection>
);
